import React from "react";

const ContactPopUp = ({setPopup})=>{

   return (
        <div style={styles.popup}>
      <div style={styles.popupContent}>
       <div className="row">
       <h4 className="fs-5 fw-6 text-center col-11">Thank You for Your Enquiry! </h4>
       <span className="col-1"><i className="fa fa-close " style={styles.closeButton} onClick={()=>setPopup(false)}></i></span>
       </div>
        <h6 className="fs-6 text-center fw-6 mt-3">Your enquiry has been successfully received.</h6>

        <article className="text-center mt-5">We truly appreciate your interest in our services and are delighted that you reached out to us. Our team is already reviewing your request and will get in touch with you shortly to provide further assistance.   </article>

        <article className="text-center mt-3">If you have any urgent questions, feel free to contact us directly via email at <a href="mailto:export@rbcil.com">export@rbcil.com</a> or via call at <a href="tel:+91 7005205341">+91 7005205341</a></article>

        <div className="mt-5">Warm regards, <br />
        RBC Infrastructure Pvt. Ltd. - Export Division</div>

      </div>
      </div>
    );

}

const styles = {
    popup: {
      display: "flex",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      justifyContent: "center",
      alignItems: "center",
      zIndex:'999'
     
    },
    popupContent: {
      width:'40rem',
      height:'auto',
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      // textAlign: "center",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    },
    closeButton: {
    //   marginTop: "10px",
      padding: "8px 12px",
      backgroundColor: "grey",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
   
    heading:{
      fontWeight : '700',
    },
  };

export default ContactPopUp;